import ApiClient from './apiClient';
import AuthService from './controllers/auth/AuthServices';
import UserService from './controllers/user/UserService';
import ProjectServices from './controllers/project/ProjectServices';
import GroupServices from './controllers/group/GroupServices';
import CategoryServices from './controllers/category/CategoryServices';
import RewardServices from './controllers/reward/RewardServices';
import LabelServices from './controllers/common/LabelServices';
import PostService from './controllers/post/PostServices';
import CommentService from './controllers/post/CommentServices';
import PostLikeService from './controllers/post/PostLikeServices';
import ChatService from './controllers/chat/ChatServices';
import DreamChatService from './controllers/dream-chat/DreamChatServices';
import EncouragementService from './controllers/encouragement/EncouragementServices';
import PublicUploaderService from './controllers/public-uploader/PublicUploaderServices';

export class ApiService {
  public auth: AuthService;

  public user: UserService;

  public project: ProjectServices;

  public group: GroupServices;

  public category: CategoryServices;

  public reward: RewardServices;
  
  public label: LabelServices;

  public post: PostService;

  public comment: CommentService;

  public postLike: PostLikeService;

  public chat: ChatService;

  public dreamChat: DreamChatService;

  public encouragement: EncouragementService;

  public publicUploader: PublicUploaderService;

  constructor() {
    this.auth = new AuthService(ApiClient);
    this.user = new UserService(ApiClient);
    this.project = new ProjectServices(ApiClient);
    this.group = new GroupServices(ApiClient);
    this.category = new CategoryServices(ApiClient);
    this.reward = new RewardServices(ApiClient);
    this.label = new LabelServices(ApiClient);
    this.post = new PostService(ApiClient);
    this.comment = new CommentService(ApiClient);
    this.postLike = new PostLikeService(ApiClient);
    this.chat = new ChatService(ApiClient);
    this.dreamChat = new DreamChatService(ApiClient);
    this.encouragement = new EncouragementService(ApiClient);
    this.publicUploader = new PublicUploaderService(ApiClient);
  }
}

const api = new ApiService();

export default api;
